// BasicInformation.js
import React from 'react';
import { Form, Input, Select, Checkbox } from 'antd';

const { Option } = Select;

const BasicInformation = ({ objectList, setSelectedObject }) => {
  
return(
  <>
    <Form.Item
      name="name"
      label="Name"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      rules={[{ required: true, message: 'Please enter the name!' }]}
    >
      <Input style={{ width: '400px' }} placeholder="Enter the name" />
    </Form.Item>
    <Form.Item
      name="objectName"
      label="Object"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      rules={[{ required: true, message: 'Object name is required!' }]}
    >
      <Select
        style={{ width: '400px' }}
        placeholder="Select Object"
        onChange={setSelectedObject}
      >
        {objectList.map((obj) => (
          <Option key={obj._id} value={obj.name}>
            {obj.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item
        name="active"
        label="Active"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>
  </>
    );
};

export default BasicInformation;